import * as s from './SealStamp.css';

export type SealStampVariant = 'mini' | 'full';

export interface SealStampProps {
  /** Sealed entry 번호 (예: 142) */
  entryNo: number;
  /** Sealed 시점 (예: "18:34") — 외부에서 포맷 후 전달 */
  sealedAt: string;
  /** 시각 크기. mini = Wizard 마지막 step / full = TodayMemo aftermath 등 */
  variant?: SealStampVariant;
  className?: string;
}

/**
 * Daily Sealed Log 모티프의 sealing ritual stamp.
 * 평상시 0, 마감 모먼트만 짧게 등장 (mount 시 0.4s scale-in fade-in).
 * cinematic fatigue 회피 — Witcher 3 / Subnautica 톤.
 *
 * 표시 어휘 (한글 친근화 — 2026-05-07):
 *   `142번째 마감 · 18:34` (이전 `ENTRY 142 · SEALED 18:34`)
 *
 * Stage 1 (Wizard 마지막 step 정중앙): variant="mini"
 * Stage 2 (TodayMemo aftermath transient): variant="full"
 */
export function SealStamp({ entryNo, sealedAt, variant = 'mini', className = '' }: SealStampProps) {
  const variantClass = variant === 'mini' ? s.stampMini : s.stampFull;
  return (
    <span className={`${s.stamp} ${variantClass} ${className}`} role="status" aria-live="polite">
      <span className={s.accentDot} aria-hidden="true" />
      <span className={s.stampText}>
        <span className={s.entryNo}>{entryNo}</span>
        <span className={s.label}>번째 마감</span>
        <span className={s.separator}>·</span>
        <span className={s.sealedTime}>{sealedAt}</span>
      </span>
    </span>
  );
}
